import React from 'react';
import { Icon, Spin, Drawer, Modal, FG, Pagination } from '../components/ui.jsx';
import { api, fmt, showToast } from '../api.js';

const ROLES = {admin:'Amministratore', manager:'Responsabile', viewer:'Operatore'};
const ROLE_COLORS = {
  admin:  {bg:'#EDE9FE',color:'#5B21B6',border:'#C4B5FD'},
  manager:{bg:'#DBEAFE',color:'#1D4ED8',border:'#93C5FD'},
  viewer: {bg:'#F3F4F6',color:'#6B7280',border:'#E5E7EB'},
};

export const UsersPage = () => {
  const [users, setUsers] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [sel, setSel] = React.useState(null);
  const [editMode, setEditMode] = React.useState(false);
  const [sav, setSav] = React.useState(false);
  const [pwModal, setPwModal] = React.useState(null);
  const [newPw, setNewPw] = React.useState('');
  const [f, setF] = React.useState({username:'',name:'',email:'',password:'',role:'viewer'});

  const load = () => api('/users').then(setUsers).catch(() => {});
  React.useEffect(() => { load(); }, []);

  const saveNew = async () => {
    if (!f.username.trim() || !f.name.trim() || !f.password.trim()) {
      showToast('Username, nome e password obbligatori', 'warn'); return;
    }
    setSav(true);
    try {
      await api('/users', 'POST', f);
      setModal(false);
      setF({username:'',name:'',email:'',password:'',role:'viewer'});
      load();
      showToast('Utente creato', 'success');
    } catch(e) {}
    finally { setSav(false); }
  };

  const saveEdit = async () => {
    if (!sel) return;
    setSav(true);
    try {
      await api(`/users/${sel.id}`, 'PATCH', {
        name: sel.name, email: sel.email || null, role: sel.role
      });
      load();
      showToast('Modifiche salvate', 'success');
      setEditMode(false);
    } catch(e) {}
    finally { setSav(false); }
  };

  const toggleActive = async (u) => {
    try {
      await api(`/users/${u.id}`, 'PATCH', {active: !u.active});
      load();
      if (sel?.id === u.id) setSel({...sel, active: !u.active});
      showToast(u.active ? 'Utente disattivato' : 'Utente riattivato', 'success');
    } catch(e) {}
  };

  const changePw = async () => {
    if (!newPw || newPw.length < 4) { showToast('Min 4 caratteri', 'warn'); return; }
    setSav(true);
    try {
      await api(`/users/${pwModal}/password`, 'POST', {password: newPw});
      setPwModal(null); setNewPw('');
      showToast('Password aggiornata', 'success');
    } catch(e) {}
    finally { setSav(false); }
  };

  const deleteUser = async (u) => {
    if (!confirm(`Eliminare l'utente ${u.name}?`)) return;
    try {
      await api(`/users/${u.id}`, 'DELETE');
      if (sel?.id === u.id) setSel(null);
      load();
      showToast('Utente eliminato', 'success');
    } catch(e) {}
  };

  const RolePill = ({role}) => {
    const c = ROLE_COLORS[role] || ROLE_COLORS.viewer;
    return <span style={{display:'inline-block',padding:'2px 9px',borderRadius:20,
      fontSize:11,fontWeight:600,background:c.bg,color:c.color,
      border:`1px solid ${c.border}`}}>{ROLES[role]||role}</span>;
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Utenti</div>
          <div className="page-title-sub">{users.filter(u=>u.active).length} attivi</div>
        </div>
        <button className="btn btn-primary" onClick={() => setModal(true)}>
          <Icon name="user-plus" size={14} color="#fff"/>Nuovo utente
        </button>
      </div>

      <div className="card" style={{padding:0}}>
        <table>
          <thead>
            <tr><th>Username</th><th>Nome</th><th>Email</th><th>Ruolo</th><th>Ultimo accesso</th><th></th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} style={{cursor:'pointer',opacity:u.active?1:0.5,
                background:sel?.id===u.id?'var(--blue-50)':''}}
                onClick={() => {setSel(u);setEditMode(false);}}>
                <td style={{fontWeight:600}}>{u.username}</td>
                <td>{u.name}</td>
                <td style={{fontSize:12,color:'var(--n400)'}}>{u.email||'—'}</td>
                <td><RolePill role={u.role}/></td>
                <td style={{fontSize:12,color:'var(--n400)'}}>
                  {u.last_login ? new Date(u.last_login).toLocaleDateString('it-IT',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'}) : 'Mai'}
                </td>
                <td style={{textAlign:'right'}}>
                  <button className="btn btn-ghost btn-sm" style={{padding:'5px 7px'}}
                    onClick={e => {e.stopPropagation();setSel(u);setEditMode(true);}}>
                    <Icon name="pencil" size={13} color="var(--n500)"/>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Drawer dettaglio / modifica */}
      <Drawer open={!!sel} onClose={() => {setSel(null);setEditMode(false);}}
        title={sel?.name} subtitle={editMode?'Modifica utente':sel?.username} width={400}>
        {sel && !editMode && (
          <div>
            <div style={{padding:'14px 16px',background:'var(--n50)',borderRadius:10,marginBottom:16}}>
              <div style={{display:'flex',alignItems:'center',gap:10}}>
                <div style={{width:44,height:44,borderRadius:'50%',
                  background:'var(--blue-50)',border:'2px solid var(--blue-pale)',
                  display:'flex',alignItems:'center',justifyContent:'center',
                  fontSize:18,fontWeight:700,color:'var(--blue)'}}>
                  {sel.name.charAt(0).toUpperCase()}
                </div>
                <div>
                  <div style={{fontWeight:700,fontSize:16}}>{sel.name}</div>
                  <div style={{display:'flex',alignItems:'center',gap:8,marginTop:4}}>
                    <RolePill role={sel.role}/>
                    {!sel.active&&<span style={{fontSize:11,color:'var(--danger)',fontWeight:600}}>DISATTIVATO</span>}
                  </div>
                </div>
              </div>
            </div>
            {sel.email&&<div style={{fontSize:12,color:'var(--n400)',marginBottom:6,display:'flex',alignItems:'center',gap:6}}>
              <Icon name="mail" size={12} color="var(--n400)"/>{sel.email}</div>}
            <div style={{fontSize:12,color:'var(--n400)',marginBottom:14,display:'flex',alignItems:'center',gap:6}}>
              <Icon name="clock" size={12} color="var(--n400)"/>
              Creato: {new Date(sel.created_at).toLocaleDateString('it-IT')}
            </div>

            <div style={{display:'flex',flexWrap:'wrap',gap:8,marginTop:20,paddingTop:14,borderTop:'1px solid var(--n100)'}}>
              <button className="btn btn-ghost btn-sm" onClick={() => setEditMode(true)}>
                <Icon name="pencil" size={13}/>Modifica</button>
              <button className="btn btn-ghost btn-sm" onClick={() => {setPwModal(sel.id);setNewPw('');}}>
                <Icon name="key-round" size={13}/>Cambia password</button>
              <button className="btn btn-ghost btn-sm" onClick={() => toggleActive(sel)}
                style={{color:sel.active?'var(--danger)':'var(--blue)'}}>
                <Icon name={sel.active?"user-x":"user-check"} size={13} color={sel.active?'var(--danger)':'var(--blue)'}/>
                {sel.active?'Disattiva':'Riattiva'}</button>
              <button className="btn btn-ghost btn-sm" onClick={() => deleteUser(sel)}
                style={{color:'var(--danger)'}}>
                <Icon name="trash-2" size={13} color="var(--danger)"/>Elimina</button>
            </div>
          </div>
        )}
        {sel && editMode && (
          <div>
            <div className="grid grid-2">
              <FG label="Nome *" span={2}>
                <input className="input" value={sel.name}
                  onChange={e => setSel({...sel, name:e.target.value})}/></FG>
              <FG label="Email">
                <input className="input" value={sel.email||''}
                  onChange={e => setSel({...sel, email:e.target.value})}/></FG>
              <FG label="Ruolo">
                <select className="input" value={sel.role}
                  onChange={e => setSel({...sel, role:e.target.value})}>
                  {Object.entries(ROLES).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
                </select></FG>
            </div>
            <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:16}}>
              <button className="btn btn-ghost" onClick={() => setEditMode(false)}>Annulla</button>
              <button className="btn btn-primary" onClick={saveEdit} disabled={sav}>
                <Icon name="save" size={13} color="#fff"/>{sav?'...':'Salva'}</button>
            </div>
          </div>
        )}
      </Drawer>

      {/* Modal nuovo utente */}
      {modal && (
        <Modal title="Nuovo utente" onClose={() => setModal(false)}>
          <div className="grid grid-2">
            <FG label="Username *">
              <input autoFocus className="input" value={f.username} placeholder="es. nicola"
                onChange={e => setF({...f, username:e.target.value.toLowerCase().replace(/[^a-z0-9._-]/g,'')})}/></FG>
            <FG label="Ruolo">
              <select className="input" value={f.role}
                onChange={e => setF({...f, role:e.target.value})}>
                {Object.entries(ROLES).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
              </select></FG>
            <FG label="Nome completo *" span={2}>
              <input className="input" value={f.name}
                onChange={e => setF({...f, name:e.target.value})}/></FG>
            <FG label="Email">
              <input className="input" value={f.email}
                onChange={e => setF({...f, email:e.target.value})}/></FG>
            <FG label="Password *">
              <input type="password" className="input" value={f.password}
                onChange={e => setF({...f, password:e.target.value})}/></FG>
          </div>
          <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:14}}>
            <button className="btn btn-ghost" onClick={() => setModal(false)}>Annulla</button>
            <button className="btn btn-primary" onClick={saveNew} disabled={sav}>
              <Icon name="user-plus" size={13} color="#fff"/>{sav?'...':'Crea utente'}</button>
          </div>
        </Modal>
      )}

      {/* Modal cambio password */}
      {pwModal && (
        <Modal title="Cambia password" onClose={() => setPwModal(null)}>
          <FG label="Nuova password *">
            <input autoFocus type="password" className="input" value={newPw}
              onChange={e => setNewPw(e.target.value)}
              onKeyDown={e => e.key==='Enter'&&changePw()}/></FG>
          <div style={{display:'flex',justifyContent:'flex-end',gap:8,marginTop:14}}>
            <button className="btn btn-ghost" onClick={() => setPwModal(null)}>Annulla</button>
            <button className="btn btn-primary" onClick={changePw} disabled={sav}>
              <Icon name="key-round" size={13} color="#fff"/>{sav?'...':'Salva password'}</button>
          </div>
        </Modal>
      )}
    </div>
  );
};
